"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwayNotifyCapability = void 0;
// dummy capability, this capability reuses the same AWAY sytax from rfc1459 for broadcasts
exports.AwayNotifyCapability = {
    name: 'away-notify'
};
